import { Box } from '@mui/material';
import { LandingPageTriangleShape } from '../../assets/shapes';
import { AppIcon } from '../../components/app-icon/AppIcon';
import { AdminRegistrationSection } from './components/admin-registration/AdminRegistrationSection';
import { FeaturedInstitutes } from './components/featured-institutes/FeaturedInstitutes';
import { FeaturedScholarships } from './components/featured-scholarships/FeaturedScholarships';
import { RegisteredStatistics } from './components/registered-statistics/RegisteredStatistics';
import { FeaturedPrograms } from './components/featured-programs/FeaturedPrograms';
import { Slider } from './components/slider/Slider';
import { homeStyles } from './styles';
import { LatestFeaturedNews } from './components/news/LatestFeaturedNews';
import { EligibilitySection } from './components/eligibility/EligibilitySection';
import { useUpdateBreadcrumb } from '../../hooks/useUpdateBreadcrumb';

export const HomePage: React.FC = () => {
  useUpdateBreadcrumb([], true);
  return (
    <>
      <Box sx={homeStyles.triangleShapeContainer}>
        <AppIcon Icon={LandingPageTriangleShape} sx={homeStyles.triangleShape} />
        <Slider />
        <EligibilitySection />
        <FeaturedScholarships />
        <RegisteredStatistics />
        <FeaturedInstitutes />
        <FeaturedPrograms />
        <LatestFeaturedNews />
        <AdminRegistrationSection />
      </Box>
    </>
  );
};
